import React from 'react'
import Layout from '../../Layout'
import CreatePublicDiscountCodeContainer from '../../../../Components/DiscountPart/CreatePublicDiscountCodeContainer/CreatePublicDiscountCodeContainer'

const CreatePublicDiscountCode = () => {
  return (
    <Layout>
        <CreatePublicDiscountCodeContainer/>
    </Layout>
  )
}

export default CreatePublicDiscountCode